
























































































import { Component, Prop, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { BDropdown } from 'bootstrap-vue';
import { CheckIcon } from 'vue-feather-icons';
import TaskSortAmountIcon from './TaskSortAmountIcon.vue';
import type { SectionSortField } from './SectionSortField';

@Component({
  name: 'TaskSectionSortMenu',
  components: {
    TaskSortAmountIcon,
    CheckIcon,
  },
})
export default class TaskSectionSortMenu extends Vue {
  @Prop({ type: String, required: true })
  sortField!: SectionSortField;

  /** When false, the text next to the icon (date sort labels) is hidden — e.g. Kanban columns. */
  @Prop({ type: Boolean, default: true })
  showTriggerLabel!: boolean;

  @Ref('dropdown') dropdownRef!: BDropdown;

  /** Shown next to the icon for date sorts only (not `manual`). */
  get sortFieldTriggerLabel(): string | null {
    switch (this.sortField) {
      case 'createdAt':
        return 'Nach Erstellungsdatum';
      case 'updatedAt':
        return 'Nach Bearbeitungsdatum';
      case 'dueAt':
        return 'Nach Fälligkeitsdatum';
      default:
        return null;
    }
  }

  get triggerAriaLabel(): string {
    const extra = this.sortFieldTriggerLabel;
    return extra ? `Sortierung: ${extra}` : 'Sortierung';
  }

  hideMenu() {
    this.dropdownRef?.hide();
  }

  onSelectField(field: SectionSortField) {
    this.hideMenu();
    if (this.sortField === field) return;
    this.$emit('set-field', field);
  }

  onOverlayOpened() {
    const header =
      this.$el.closest?.('.todo-section-header') || this.$el.closest?.('.task-kanban-board-header');
    header?.classList?.add('todo-section-sort-dropdown-open');
  }

  onOverlayClosed() {
    const header =
      this.$el.closest?.('.todo-section-header') || this.$el.closest?.('.task-kanban-board-header');
    header?.classList?.remove('todo-section-sort-dropdown-open');
  }
}
